'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgArrowRight, SvgChevronleft, SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';
import { Image } from '@/components/client';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
import { useGlobalStore } from '@/stores/GlobalStore';
const SLIDE_IMAGE_BASE = 'https://cdn.welfarehello.com/static/home';
const REWARD_SLIDES = [{
  src: `${SLIDE_IMAGE_BASE}/reward-1.png`,
  alt: '이달의 혜택 메인 화면'
}, {
  src: `${SLIDE_IMAGE_BASE}/reward-2.png`,
  alt: '미션 추천 화면'
}, {
  src: `${SLIDE_IMAGE_BASE}/reward-3.png`,
  alt: '리워드 충전소 홈 화면'
}, {
  src: `${SLIDE_IMAGE_BASE}/reward-4.png`,
  alt: '전체 미션 화면'
}];
const REWARD_BENEFITS = [{
  lead: '',
  highlight: '현금성 웰포인트',
  tail: ' 적립'
}, {
  lead: '',
  highlight: '네이버페이 포인트',
  tail: ' 등 모바일 쿠폰 교환 가능'
}, {
  lead: '매일 갱신되는 미션으로 ',
  highlight: '꾸준한 적립',
  tail: ''
}];
export const AppInstallConfirmModal = () => {
  const $ = _c(55);
  const router = useCustomRouter();
  const [isShowAppInstallConfirmModal, setIsShowAppInstallConfirmModal] = useGlobalStore(_temp);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      loop: true,
      align: "center"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t0);
  let t1;
  if ($[1] !== emblaApi) {
    t1 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    $[1] = emblaApi;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onSelect = t1;
  let t2;
  let t3;
  if ($[3] !== emblaApi || $[4] !== onSelect) {
    t2 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t3 = [emblaApi, onSelect];
    $[3] = emblaApi;
    $[4] = onSelect;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== setIsShowAppInstallConfirmModal) {
    t4 = () => setIsShowAppInstallConfirmModal(false);
    $[7] = setIsShowAppInstallConfirmModal;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useOverlayHistory(isShowAppInstallConfirmModal, t4);
  let t5;
  if ($[9] !== setIsShowAppInstallConfirmModal) {
    t5 = () => setIsShowAppInstallConfirmModal(false);
    $[9] = setIsShowAppInstallConfirmModal;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleClose = t5;
  let t6;
  if ($[11] !== router || $[12] !== setIsShowAppInstallConfirmModal) {
    t6 = () => {
      setIsShowAppInstallConfirmModal(false);
      router.push(ROUTES.APP_DOWNLOAD.pathname);
    };
    $[11] = router;
    $[12] = setIsShowAppInstallConfirmModal;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleClickInstall = t6;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="inline-flex items-center gap-4 rounded-pill bg-B-50 px-8 py-4 font-700 text-B-500 typo-caption2">📱 모바일 앱 전용 혜택</span>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <header className="flex flex-col items-center gap-8">{t7}<h2 className="break-keep text-center font-800 text-Gray-900 typo-h6">매일 미션 참여하고{" "}<b className="font-800 text-B-500">현금처럼 쓰는 포인트</b> 받기</h2><p className="whitespace-pre-line break-keep text-center font-400 text-Gray-500 typo-caption1">웰로 앱에서만 만나는 리워드 충전소,{"\n"}지금 어떤 혜택이 있는지 살펴보세요.</p></header>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex">{REWARD_SLIDES.map(_temp2)}</div>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== emblaRef) {
    t10 = <div className="overflow-hidden" ref={emblaRef}>{t9}</div>;
    $[17] = emblaRef;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== emblaApi) {
    t11 = () => emblaApi?.scrollPrev();
    $[19] = emblaApi;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SvgChevronleft className="size-16" />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11) {
    t13 = <button aria-label={"\uC774\uC804 \uD61C\uD0DD"} className="absolute left-0 top-1/2 flex size-32 -translate-y-1/2 items-center justify-center rounded-pill border border-Gray-100 bg-Gray-white text-Gray-600 shadow-base" onClick={t11} type="button">{t12}</button>;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== emblaApi) {
    t14 = () => emblaApi?.scrollNext();
    $[24] = emblaApi;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SvgChevronright className="size-16" />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14) {
    t16 = <button aria-label={"\uB2E4\uC74C \uD61C\uD0DD"} className="absolute right-0 top-1/2 flex size-32 -translate-y-1/2 items-center justify-center rounded-pill border border-Gray-100 bg-Gray-white text-Gray-600 shadow-base" onClick={t14} type="button">{t15}</button>;
    $[27] = t14;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t10 || $[30] !== t13 || $[31] !== t16) {
    t17 = <div className="relative w-full">{t10}{t13}{t16}</div>;
    $[29] = t10;
    $[30] = t13;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== emblaApi || $[34] !== selectedIndex) {
    t18 = REWARD_SLIDES.map((slide_0, index) => <button key={slide_0.src} aria-current={index === selectedIndex} aria-label={`${index + 1}번 혜택`} className={cn("h-4 rounded-pill transition-colors duration-200", index === selectedIndex ? "w-16 bg-B-500" : "w-4 bg-Gray-300")} onClick={() => emblaApi?.scrollTo(index)} type="button" />);
    $[33] = emblaApi;
    $[34] = selectedIndex;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t18) {
    t19 = <div className="flex items-center gap-4">{t18}</div>;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t17 || $[39] !== t19) {
    t20 = <div className="flex flex-col items-center gap-8">{t17}{t19}</div>;
    $[38] = t17;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="flex flex-col gap-4 rounded-small bg-B-25 px-16 py-12 text-left"><ul className="flex flex-col gap-8">{REWARD_BENEFITS.map(_temp3)}</ul></div>;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <SvgArrowRight className="size-20" />;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== handleClickInstall) {
    t23 = <Button dimensions="H48" onClick={handleClickInstall} theme="secondary-fill">앱 설치하고 혜택 받기{t22}</Button>;
    $[43] = handleClickInstall;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== handleClose) {
    t24 = <button className="font-500 text-Gray-400 underline underline-offset-2 typo-caption2" onClick={handleClose} type="button">다음에 볼게요</button>;
    $[45] = handleClose;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t20 || $[48] !== t23 || $[49] !== t24) {
    t25 = <div className="flex flex-col gap-12">{t8}{t20}{t21}{t23}{t24}</div>;
    $[47] = t20;
    $[48] = t23;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== handleClose || $[52] !== isShowAppInstallConfirmModal || $[53] !== t25) {
    t26 = <ResponsiveDialog opened={isShowAppInstallConfirmModal} onClose={handleClose}>{t25}</ResponsiveDialog>;
    $[51] = handleClose;
    $[52] = isShowAppInstallConfirmModal;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  return t26;
};
function _temp(state) {
  return [state.isShowAppInstallConfirmModal, state.setIsShowAppInstallConfirmModal];
}
function _temp2(slide) {
  return <div key={slide.src} className="flex min-w-0 flex-[0_0_100%] justify-center"><div className="relative aspect-[3/4] w-180 overflow-hidden rounded-large border border-Gray-100 [-webkit-mask-image:linear-gradient(to_bottom,black_88%,transparent)] [mask-image:linear-gradient(to_bottom,black_88%,transparent)]"><Image alt={slide.alt} className="object-cover object-top" fill={true} sizes="180px" src={slide.src} /></div></div>;
}
function _temp3(t0) {
  const {
    lead,
    highlight,
    tail
  } = t0;
  return <li key={highlight} className="flex items-start gap-8 break-keep font-400 text-Gray-800 typo-caption1"><span className="mt-6 size-4 shrink-0 rounded-pill bg-B-500" /><span>{lead}<b className="font-700 text-B-600">{highlight}</b>{tail}</span></li>;
}